import { createStore } from "vuex";
import { Prospect } from "@/store/prospect";
import { RecoveryQuestion } from "@/services/onboarding/onboarding-service";

export enum StoreActions {
  setProspect = "setProspect",
  setJwt = "setJwt",
  setRecoveryQuestions = "setRecoveryQuestions",
}

const store = createStore({
  state: {
    prospect: new Prospect(),
    jwt: "",
    recoveryQuestions: <RecoveryQuestion[]>[],
  },
  mutations: {
    setProspect(state, prospect: Prospect) {
      state.prospect = prospect;
    },
    setJwt(state, jwt: string) {
      state.jwt = jwt;
    },
    setRecoveryQuestions(state, recoveryQuestions: RecoveryQuestion[]) {
      state.recoveryQuestions = recoveryQuestions;
    },
  },
  actions: {
    [StoreActions.setProspect]: ({ commit }, prospect) => {
      commit("setProspect", prospect);
    },
    [StoreActions.setJwt]: ({ commit }, jwt) => {
      commit("setJwt", jwt);
    },
    [StoreActions.setRecoveryQuestions]: ({ commit }, recoveryQuestions) => {
      commit("setRecoveryQuestions", recoveryQuestions);
    },
  },
  getters: {
    prospect(state) {
      return state.prospect;
    },
    jwt(state) {
      return state.jwt;
    },
    recoveryQuestions(state) {
      return state.recoveryQuestions;
    },
  },
});

export default store;
